// Helper for linking to pieces of content
import { APP_MAPPING_BY_SLUG } from "../../../config";

function linkToProgramOverview(programSlug, activeHubSlug) {
  const routeSlug = APP_MAPPING_BY_SLUG[activeHubSlug].route;
  return "/" + activeHubSlug + "/" + routeSlug + "/" + programSlug;
}

export default linkToProgramOverview
